<div *ngIf="browseType=='productType'" class="container">
  <h2 class="strong">{{item[0].name}}</h2>
  <div *ngFor="let items of item,let i=index ">
    <app-list-card  [productInfo]=items [browseType]=browseType [index]=index></app-list-card>
  </div>
</div>

<div *ngIf="browseType=='port'" class="container">
  <h2 class="strong">{{item.name}}</h2>
  <div *ngFor="let product of item.products,let i=index ">
    <app-list-card [port]=item [productInfo]=product [browseType]=browseType [index]=index></app-list-card>
  </div>
</div>
